import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import { TenantCertificationComponent } from './tenant-certification.component';
import { Permission } from 'src/app/models/principal/permission';
import { PermissionGuard } from 'src/app/services/util/permission.guard';
import { ExternalTenantGuard } from 'src/app/services/util/external-tenant.guard';

const routes: Routes = [
  {
    path: '',
    component: TenantCertificationComponent,
    title: 'Certificate',
    canActivate: [ExternalTenantGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TenantCertificationRoutingModule {
}
